<script>
    export let tags; // list of tag string
    import Tags from "./Tags.svelte";
    import { nextId } from "./id_generator.js";

    $: mappedTags = (tags || []).map((x) => ({ id: nextId(), value: x }));
    function onTags(event) {
        tags = event.detail.tags.map((x) => x.value);
    }
</script>

<Tags tags={mappedTags} on:tags={onTags} dragDisabled={true} />
